import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Board from './components/Board';
import { generateBoardId } from './utils/boardUtils';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to={`/${generateBoardId()}`} replace />} />
        <Route path="/:boardId" element={<Board />} />
      </Routes>
    </div>
  );
}

export default App;
